import React, { useEffect } from "react";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import ErrorRoundedIcon from "@mui/icons-material/ErrorRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { useDispatch, useSelector } from "react-redux";
import { setnotification } from "../../redux/actions/styles";

const Notification = () => {
  const dispatch = useDispatch();

  const { notification } = useSelector((state) => state.styles);
  const { type, text, visible } = notification;

  useEffect(() => {
    let timeout;
    if (visible) {
      timeout = setTimeout(() => {
        dispatch(setnotification({ ...notification, visible: false }));
      }, 3000);
    }
    return () => clearTimeout(timeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  return (
    <div className={`notification ${visible ? "active" : ""}`}>
      <div className="type-icon">
        {type === "info" && <InfoRoundedIcon style={{ color: "var(--color-info)" }} />}
        {type === "success" && <CheckCircleRoundedIcon style={{ color: "var(--color-success)" }} />}
        {type === "error" && <ErrorRoundedIcon style={{ color: "var(--color-danger)" }} />}
      </div>
      <p className="not-text">{text}</p>
      <div className="cross" onClick={() => dispatch(setnotification({ ...notification, visible: false }))}>
        <CloseRoundedIcon />
      </div>
    </div>
  );
};

export default Notification;
